import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Form, Input, Button, Progress, Alert } from 'antd'
import passwordStrengthTest from 'tai-password-strength'
import WeaverService from 'Services/WeaverService'
{ Item } = Form
{ Password } = Input

export default ChangePassword = ({ user, closeModal }) ->

  history = useHistory()
  [passwordVal, setPasswordVal] = useState("")
  [error, setError] = useState(undefined)
  [disabled, setDisabled] = useState(true)

  formLayout =
    labelCol: { span: 24 }
    wrapperCol: { span: 24 }

  getPasswordEntropy = (password) ->
    passwordTest = new passwordStrengthTest.PasswordStrength()
    { shannonEntropyBits } = passwordTest.check(password)
    shannonEntropyBits

  showPasswordEntropy = ->
    entropy = getPasswordEntropy(passwordVal)
    status = if entropy < 25 then 'exception' else if entropy > 60 then 'success' else 'normal'
    text = if entropy < 25 then 'weak' else if entropy > 60 then 'strong' else 'medium'
    <div style={{ marginBottom: '20px' }}>
      <Progress showInfo={false} percent={entropy} status={status} />
      <span style={{ color: 'grey' }}>Password strength: <strong>{ text }</strong></span>
    </div>

  handlePasswordChange = ({ password }) ->
    try
      await user.changePassword(password)
      closeModal()
    catch e
      console.error e
      console.error e.toString()
      setError(e.toString())

  <>
    { error and
      <Alert
        message="Error changing password"
        description={error}
        type="error"
        showIcon
      />
    }
    <Form
      { formLayout... }
      name="change-password"
      initialValues={{ remember: true }}
      onFinish={handlePasswordChange}
      onFieldsChange={(currentField, allFields) ->
        setError(undefined) if error
        isValidated = allFields.every(({ touched, errors })-> touched and not errors.length)
        if isValidated
          setDisabled(false)
        else
          setDisabled(true) if not disabled
      }
    >
      <Item
        style={{ marginBottom: '0px' }}
        label="New password"
        name="password"
        extra="Choose a strong password that consists of at least 9 characters, 1 number, 1 symbol"
        rules={[
          {
            required: true
            message: 'Choose a password'
          },{
            min: 9
            message: 'Your password should contain at least 9 characters'
          },
          {
            pattern: /[a-zA-Z]/
            message: 'Your password should contain at least 1 letter'
          },
          {
            pattern: /[0-9]/
            message: 'Your password should contain at least 1 number'
          },
          {
            pattern: /[^a-zA-Z0-9]/
            message: 'Your password should contain at least 1 symbol'
          },
          validator: (rule, value) ->
            entropy = getPasswordEntropy(value)
            if entropy < 25 then Promise.reject("The password is too weak") else Promise.resolve()
        ]}
      >
        <Password
          placeholder="Password"
          onChange={(e) -> setPasswordVal(e.target.value)}
        />
      </Item>
      { showPasswordEntropy() }
      <Item
        label="Repeat password"
        name="password2"
        rules={[
          {
            required: true
            message: 'Choose a password'
          },{
            min: 9
            message: 'Your password should contain at least 9 characters'
          },
          ({ getFieldValue }) ->
            validator: (rule, value) ->
              if not value or getFieldValue('password') is value
                Promise.resolve()
              else
                Promise.reject("The provided passwords don't match")
        ]}
      >
        <Password placeholder="Password"/>
      </Item>
      <Item>
        <Button
          data-testid="change-password-bttn"
          disabled={disabled}
          type="primary"
          size="large"
          htmlType="submit"
          style={{ marginTop: 5 }}
        >
          Change
        </Button>
      </Item>
    </Form>
  </>
